<template>
	<div class="html-iframe-shell">
		<!-- 左侧：上传 + 控制按钮 + 日志列表 -->
		<div class="html-iframe-sidebar" v-if="configMode || (isplayF!=2&&htmlSimulation)">
			<div v-if="configMode" class="layer-config-panel">
				<div class="layer-config-head">
					<div>
						<h4>操作记录</h4>
						<p>新增分层方法后，在右侧页面录制老师操作步骤。</p>
					</div>
					<el-button type="primary" size="mini" icon="el-icon-plus" :disabled="hasRecordingLayer"
						@click="addLayerMethod">新增分层空间</el-button>
				</div>

				<div v-if="stratifiedLoading" class="rule-loading">
					<i class="el-icon-loading"></i>
					<span>规则加载中...</span>
				</div>
				<div v-else class="layer-method-list">
					<div v-for="(method, index) in layerMethods" :key="method.id" class="layer-method-card"
						:class="{ active: activeLayerId === method.id, recording: method.recording }"
						@click="activeLayerId = method.id">
						<div class="method-top">
							<span class="method-index">{{ index + 1 }}</span>
							<el-input v-model.trim="method.name" size="mini" placeholder="请输入方法名称"
								@focus="activeLayerId = method.id" @click.native.stop />
							<span v-if="method.recording" class="recording-pill">录制中</span>
							<span v-else-if="isMethodCompleted(method)" class="completed-pill">已录制</span>
						</div>
						<div class="method-actions">
							<el-button size="mini" :type="getRecordButtonType(method)"
								:disabled="isRecordButtonDisabled(method)"
								@click.stop="toggleLayerRecord(method)">
								{{ getRecordButtonText(method) }}
							</el-button>
							<el-button size="mini" icon="el-icon-video-play"
								:disabled="hasRecordingLayer || method.steps.length === 0"
								@click.stop="playLayerMethod(method)">回放</el-button>
							<el-button size="mini" icon="el-icon-refresh-left"
								:disabled="method.recording || method.steps.length === 0"
								@click.stop="resetLayerMethod(method)" title="重置">重置</el-button>
							<el-button size="mini" type="danger" plain icon="el-icon-delete"
								@click.stop="removeLayerMethod(method.id)">删除</el-button>
							<span class="step-count">{{ getMethodStepCount(method) }} 步</span>
						</div>
					</div>
				</div>

				<div class="method-log-panel">
					<div class="method-log-title">
						<div>
							<strong>{{ activeLayerMethod ? (activeLayerMethod.name || '未命名方法') : '未选择方法' }}</strong>
							<span>{{ activeLayerMethod ? `${getMethodStepCount(activeLayerMethod)} 条记录` : '0 条记录' }}</span>
						</div>
						<el-button size="mini" icon="el-icon-video-play"
							:disabled="!activeLayerMethod || activeLayerMethod.recording || activeLayerMethod.steps.length === 0"
							@click="playLayerMethod(activeLayerMethod)">回放当前方法</el-button>
					</div>
					<!-- 配置页操作记录表：功能列对应 displayStepName，参数列对应 formatStepArgs，操作时间列对应 formatTime。 -->
					<div id="logBox" class="config-log-box">
						<table class="config-log-table">
							<thead>
								<tr>
									<th class="thTable thTables">序号</th>
									<th class="thTable">功能</th>
									<th class="thTable">参数</th>
									<th class="thTable">操作时间</th>
								</tr>
							</thead>
							<tbody id="logTbody">
								<tr v-if="!activeLayerMethod || activeLayerMethod.steps.length === 0">
									<td class="empty-log-cell" colspan="4">暂无操作记录</td>
								</tr>
								<template v-else>
									<tr v-for="(step, stepIndex) in activeLayerMethod.steps" :key="step.localId">
										<td class="log-td log-index">{{ stepIndex + 1 }}</td>
										<!-- 功能名称：优先展示老师操作的控件文本，其次展示 targetId 或 funcName。 -->
										<td class="log-td" :title="displayStepName(step)">{{ displayStepName(step) }}</td>
										<td class="log-td log-args" :title="formatStepArgs(step.args)">{{ formatStepArgs(step.args) }}</td>
										<!-- 操作时间：使用原有 formatTime 统一格式，样式对应 .log-time。 -->
										<td class="log-td log-time">{{ formatTime(step.timestamp) }}</td>
									</tr>
								</template>
							</tbody>
						</table>
					</div>
				</div>

				<!-- 2026-07-29 HTML分层配置页底部按钮：录制中显示停止录制，非录制显示保存配置。 -->
				<div class="layer-config-footer">
					<el-button @click="closeLayerConfig">关闭</el-button>
					<el-button v-if="hasRecordingLayer" type="warning" @click="stopActiveLayerRecord">停止录制</el-button>
					<el-button v-else type="primary" :loading="stratifiedSaving" @click="saveLayerConfig">保存配置</el-button>
				</div>
			</div>
			<div v-if="!configMode && (isplayF==0||isplayF==1)"
				style="flex:1;background:#fff;padding:16px;border-radius:6px;border:1px solid #eee;display:flex;flex-direction:column;overflow:hidden;">
				<h4 style="margin:0 0 10px 0;">操作记录</h4>
				<div style="display:flex;gap:8px;flex-wrap:wrap;">
					<div v-if="isplayF==0" @click="startPlayback" :disabled="state.playQueue.length==0||isp"
						title="开始回放"><img style="width: 26px;height: 26px;" src="@/ico/classBegins.svg" /></div>
					<div v-if="isplayF==1" @click="startPlayback" :disabled="state.playQueue.length==0" title="开始回放">
						<img style="width: 26px;height: 26px;" src="@/ico/classBegins.svg" /></div>
					<div @click="pausePlayback" v-if="state.isPlaying&&!state.isPause" title="暂停"><img
							style="width: 26px;height: 26px;" src="@/ico/pause.svg" /></div>
					<div @click="resumePlayback" v-if="state.isPause === true && state.isPlaying" title="继续"><img
							style="width: 26px;height: 26px;" src="@/ico/cfontinue.svg" /></div>
					<div v-if="showContinueOperateBtn" @click="handleContinueOperate" title="重置回放"><img
							style="width: 26px;height: 26px;" src="@/ico/reset.svg" /></div>
					<div v-if="userType==2&&isSave&&isplayF!=0" @click="classToExl" title="全部分析"><img
							style="width: 26px;height: 26px;" src="@/ico/analysis.svg" /></div>
				</div>
				<div id="logBox" style="width:100%;flex:1;border:1px solid #ddd;overflow-y:auto;background:#fff;">
					<table style="width:100%;border-collapse:collapse;font-family:monospace;">
						<thead>
							<tr style="background:#f5f7fa;">
								<th class="thTable thTables">序号</th>
								<th class="thTable">功能</th>
								<th class="thTable">参数</th>
								<th class="thTable">操作时间</th>
							</tr>
						</thead>
						<tbody id="logTbody"></tbody>
					</table>
				</div>
			</div>
		</div>

		<!-- 右侧单个iframe -->
		<div class="html-iframe-stage">
			<div class="iframe-stage-head" v-if="isplayF==0||isplayF==1">回放页面</div>
			<div style="flex:1; position: relative;">
				<iframe ref="cubeIframe" id="cubeIframe" :src="currentIframeSrc" frameborder="0" width="100%"
					style="height:100%;"></iframe>
				<div v-if="isplayF == 1&&htmlSimulation" style="
			        position: absolute;
			        top: 0;
			        left: 0;
			        width: 100%;
			        height: 100%;
			        background: rgba(0,0,0,0.05); /* 半透明灰，可改透明 transparent */
			        z-index: 10;
			        pointer-events: all; /* 拦截所有鼠标点击、hover、滚动 */
			      "></div>
			</div>
		</div>
		<el-dialog title="网页模拟统计" :visible.sync="ishtmlView" width="100vw" top="0" :before-close="handleCloseDialog"
			append-to-body :z-index="2999" style="overflow: hidden; height: 100vh; margin: 0; padding: 0;">
			<!-- 弹性容器：扣除标题高度，剩余全部给子组件 -->
			<div style="width:100%;height:calc(100vh - 52px);">
				<HtmlAnalysis style="width: 100%;height: 100%;" :srcUrl="url" :htmlId="htmlId" :courseClassId="courseClassId" :studentId="studentId">
				</HtmlAnalysis>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import HtmlAnalysis from "@/views/student/test 1/components/analysis/HtmlAnalysis.vue"
	export default {
		name: "HtmlInjectPlaybackWrapper",
		props: {
			iframeUrlOrigin: String,
			iframeUrlPlay: String,
			url: String,
			htmlId: {
				type: Number,
				default:0
			},
			isplayF: {
				type: Number,
				default: 0
			},
			
			studentId: {
				type: String,
				default: ''
			},
			courseClassId: {
				type: String,
				default: ''
			},
			configMode: {
				type: Boolean,
				default: false
			},
			layerConfig: {
				type: Array,
				default: () => []
			},
			htmlUploadRecordId: {
				type: [String, Number],
				default: ''
			}
		},
		components: {
			HtmlAnalysis
		},
		computed: {
			iframeEl() {
				return this.$refs.cubeIframe;
			},
			activeLayerMethod() {
				return this.layerMethods.find(item => item.id === this.activeLayerId) || null
			},
			hasRecordingLayer() {
				return this.layerMethods.some(item => item.recording)
			}
		},
		data() {
			return {
				rawHtml: "",
				processedHtml: "",
				cachePlaySnapshot: "", // 回放前缓存用户操作页面快照
				currentIframeSrc: "",
				showContinueOperateBtn: false,
				isPlayMode: false, // true=回放模式 屏蔽录制上报
				playTimer: null, // 回放定时器，防止堆积
				msgCache: new Set(), // 组件私有消息去重缓存，替代全局window._msgCache
				state: {
					recordQueue: [],
					playQueue: [],
					currentPlayIndex: -1,
					isPause: false,
					isPlaying: false,
					iframeReady: false,
					logIndex: 0
				},
				uploadFileName: '',
				login: null,
				userType: localStorage.getItem("userType"),
				isSave: localStorage.getItem('isSave') || false,
				htmlindex: 1,
				isp: false,
				getHtmlist: false,
				htmlSimulation: false,
				ishtmlView: false,
				layerMethods: [],
				activeLayerId: '',
				layerIdSeed: 1,
				stepIdSeed: 1,
				stratifiedLoading: false,
				stratifiedSaving: false,
				rulesLoadedRecordId: '',
			};
		},
		watch: {
			configMode: {
				handler(val) {
					if (val) {
						this.loadStratifiedRules()
					}
				},
				immediate: true
			},
			layerConfig: {
				handler(val) {
					if (this.configMode && !this.getHtmlUploadRecordId()) {
						this.initLayerMethods(val)
					}
				},
				deep: true
			},
			htmlUploadRecordId() {
				if (this.configMode) {
					this.loadStratifiedRules(true)
				}
			},
			iframeUrlOrigin: {
				handler(newVal) {
					this.forMenuList()
					if (!newVal) return;
					this.cachePlaySnapshot = "";
					// 2026-07-17 Student HTML simulator: keep iframe visible when async blob props arrive out of order.
					this.currentIframeSrc = this.iframeUrlPlay || newVal || this.url;
					this.isPlayMode = false;

					// 清空所有回放状态
					this.state = {
						recordQueue: [],
						playQueue: [],
						currentPlayIndex: -1,
						isPause: false,
						isPlaying: false,
						iframeReady: false,
						logIndex: 0
					};
					this.showContinueOperateBtn = false;
					// 清空日志表格
					const logTbody = document.getElementById('logTbody');
					if (logTbody) logTbody.innerHTML = '';

					this.$nextTick(() => {
						const iframe = document.getElementById("cubeIframe");
						// 清空旧事件监听，避免重复执行
						iframe.onload = null;
						iframe.onerror = null;
						iframe.onload = () => {
							// 延迟等待iframe内部脚本初始化完成
							setTimeout(() => {
								this.state.iframeReady = true;
								this.resetPlayback();
							}, 300);
						};

						// 加载失败兜底
						iframe.onerror = () => {
							this.$message.error("预览页面加载失败");
							this.state.iframeReady = true;
						};
					});
					if (!this.getHtmlist) {
						this.getHtmlist = true
						this.getlistForPlayback()
						setTimeout(() => {
							this.getHtmlist = false
						}, 1000)
					}

					this.isp = false
				},
				immediate: true
			},
			iframeUrlPlay(newVal) {
				if (!newVal || this.isPlayMode) return
				// 2026-07-17 Student HTML simulator: update display when play blob arrives after origin blob.
				this.currentIframeSrc = newVal
			},
			url(newVal) {
				if (!newVal || this.currentIframeSrc || this.iframeUrlPlay) return
				// 2026-07-17 Student HTML simulator: final fallback for pages that only pass url.
				this.currentIframeSrc = newVal
			}
		},
		created() {
			

		},
		mounted() {
			window.addEventListener("message", this.onParentMessage);
		},
		beforeDestroy() {
			// 清除回放定时器
			if (this.playTimer) clearTimeout(this.playTimer);
			// 清空组件消息缓存
			this.msgCache.clear();
			// 重置状态
			this.state = {
				recordQueue: [],
				playQueue: [],
				currentPlayIndex: -1,
				isPause: false,
				isPlaying: false,
				iframeReady: false,
				logIndex: 0
			}
			// 移除全局消息监听，防止多组件冲突
			window.removeEventListener("message", this.onParentMessage);
			// 释放blob内存
			if (this.iframeUrlOrigin) URL.revokeObjectURL(this.iframeUrlOrigin);
			if (this.iframeUrlPlay) URL.revokeObjectURL(this.iframeUrlPlay);
			if (this.cachePlaySnapshot) URL.revokeObjectURL(this.cachePlaySnapshot);
		},
		methods: {
			getHtmlUploadRecordId() {
				return this.htmlUploadRecordId === 0 ? 0 : (this.htmlUploadRecordId || '')
			},
			getResponseData(res) {
				if (!res) return null
				if (res.data && res.data.data !== undefined) return res.data.data
				if (res.data !== undefined) return res.data
				return res
			},
			// 2026-07-17 HTML stratified render: support common backend wrappers for saved rule list/detail.
			extractStratifiedRuleList(payload) {
				const data = this.unwrapStratifiedPayload(payload)
				if (Array.isArray(data)) return data
				if (!data || typeof data !== 'object') return []
				const candidates = [
					data.records,
					data.rows,
					data.list,
					data.ruleList,
					data.rules,
					data.data && data.data.records,
					data.data && data.data.rows,
					data.data && data.data.list,
					data.data && data.data.ruleList,
					data.data && data.data.rules
				]
				for (const item of candidates) {
					if (Array.isArray(item)) return item
				}
				return this.isStratifiedRuleObject(data) ? [data] : []
			},
			unwrapStratifiedPayload(payload) {
				let data = payload
				let guard = 0
				while (data && typeof data === 'object' && !Array.isArray(data) && data.data !== undefined && guard < 3) {
					const keys = Object.keys(data)
					if (keys.length > 3 || data.records || data.rows || data.list || data.ruleList || data.rules) break
					data = data.data
					guard += 1
				}
				return data
			},
			isStratifiedRuleObject(item) {
				if (!item || typeof item !== 'object') return false
				return item.layerId !== undefined || item.layerName !== undefined || item.steps !== undefined || item.ruleId !== undefined || item.htmlStratifiedRuleId !== undefined
			},
			// 2026-07-17 HTML stratified replay: list rows may return rule primary key as id/ruleId/custom id.
			getRulePrimaryId(item = {}) {
				if (!item || typeof item !== 'object') return ''
				return item.id || item.ruleId || item.rule_id || item.htmlStratifiedRuleId || item.stratifiedRuleId || item.rulePrimaryId || ''
			},
			extractStratifiedRuleDetail(payload, fallback) {
				const data = this.unwrapStratifiedPayload(payload)
				if (Array.isArray(data)) return data[0] || fallback
				if (!data || typeof data !== 'object') return fallback
				if (this.isStratifiedRuleObject(data)) return data
				const list = this.extractStratifiedRuleList(data)
				if (list.length > 0) return list[0]
				return data.rule || data.detail || fallback
			},
			syncRuleIdsFromSaveResponse(payload) {
				const list = this.extractStratifiedRuleList(payload)
				if (list.length === 0) return
				const byLayerId = {}
				list.forEach(item => {
					if (item && item.layerId) byLayerId[item.layerId] = item
				})
				this.layerMethods.forEach((method, index) => {
					const matched = byLayerId[method.id] || list[index]
					if (!matched) return
					if (matched.id) method.ruleId = matched.id
					if (matched.ruleId) method.ruleId = matched.ruleId
					if (matched.layerId) method.id = matched.layerId
				})
			},
			// 2026-07-17 HTML stratified replay: server refresh must not erase local recorded steps after save.
			mergeLoadedMethodsWithLocalSteps(loadedMethods, localMethods) {
				return loadedMethods.map(method => {
					if (method.steps.length > 0) return method
					const local = localMethods.find(item => (
						(method.ruleId && item.ruleId && String(method.ruleId) === String(item.ruleId)) ||
						(method.id && item.id && String(method.id) === String(item.id)) ||
						(method.name && item.name && method.name === item.name)
					))
					if (!local || local.steps.length === 0) return method
					return {
						...method,
						steps: local.steps.map((step, stepIndex) => this.normalizeLayerStep(step, stepIndex))
					}
				})
			},
			createUniqueLayerId() {
				let id = ''
				do {
					id = `layer_${Date.now()}_${this.layerIdSeed++}`
				} while (this.layerMethods.some(item => item.id === id))
				return id
			},
			parseRuleSteps(steps) {
				// 2026-07-29 规则步骤解析：详情接口可能返回数组、对象或 JSON 字符串，页面统一使用数组。
				if (Array.isArray(steps)) return steps
				if (!steps) return []
				if (typeof steps === 'object') {
					if (Array.isArray(steps.steps)) return steps.steps
					if (Array.isArray(steps.list)) return steps.list
					if (Array.isArray(steps.records)) return steps.records
					if (Array.isArray(steps.rows)) return steps.rows
					return []
				}
				try {
					const parsed = JSON.parse(steps)
					return this.parseRuleSteps(parsed)
				} catch (e) {
					return []
				}
			},
			normalizeRuleFromServer(item = {}) {
				const ruleId = this.getRulePrimaryId(item)
				const steps = this.parseRuleSteps(item.steps || item.stepList || item.operateSteps || item.operateRecordList || item.recordList)
				return {
					id: item.layerId || item.layer_id || item.id || this.createUniqueLayerId(),
					ruleId: ruleId || 0,
					name: item.layerName || item.layer_name || item.name || '',
					recording: false,
					stepCount: Number(item.stepCount || steps.length || 0),
					steps: steps.map((step, stepIndex) => this.normalizeLayerStep(step, stepIndex))
				}
			},
			async getRuleDetail(item) {
				// 2026-07-29 规则详情读取：列表接口只给规则元信息，使用规则主键补齐可回放的步骤。
				const ruleId = this.getRulePrimaryId(item)
				if (!item || !ruleId) return []
				try {
					const res = await this.API.get(this.API.fileurl.getHtmlStratifiedId + ruleId)
					const detail = this.getResponseData(res)
					return this.parseRuleSteps(detail && detail.steps !== undefined ? detail.steps : detail)
				} catch (err) {
					console.warn('html stratified detail skipped', err)
					return []
				}
			},
			async loadStratifiedRules(force = false) {
				const recordId = this.getHtmlUploadRecordId()
				if(!this.htmlUploadRecordId) return this.$message('网页文件异常请关闭后重新打开')
				this.rulesLoadedRecordId=''
				this.layerMethods=[]
				this.stratifiedLoading = true
				try {
					const res = await this.API.get(this.API.fileurl.getHtmlStratifiedList, {
						htmlUploadRecordId: this.htmlUploadRecordId
					})
					// 2026-07-29 标准模型配置初始化：保留原接口行，并按 layerId/ruleId 映射。
					// 不能用通用对象归一化替换，否则会改变配置页后续保存与回放依赖的主键关系。
					let listData = Array.isArray(res && res.data && res.data.data) ? res.data.data : []
					for (const item of listData) {
						try {
							// getRuleDetail 负责把服务端 JSON 字符串转换为步骤数组；没有记录时返回空数组。
							item.steps = await this.getRuleDetail(item)
						} catch (err) {
							item.steps = []
						} finally {
							item.name = item.layerName || item.name || ''
							item.ruleId = item.id || item.ruleId || 0
							item.id = item.layerId || item.id
							item.recording = false
							item.stepCount = Number(item.stepCount || item.steps.length || 0)
						}
					}

					this.layerMethods = listData
					if (this.layerMethods.length === 0) {
						// 没有保存过规则时，清空后进入默认新增状态，符合原初始化要求。
						this.addLayerMethod()
					} else {
						this.activeLayerId = this.layerMethods[0].id
					}
					this.rulesLoadedRecordId = String(recordId)
					this.$nextTick(() => this.syncActiveRecordQueue())
				} catch (err) {
					// console.warn('html stratified rules load failed', err)
					this.addLayerMethod()
					// this.initLayerMethods(this.layerConfig)
				} finally {
					this.stratifiedLoading = false
				}
			},
			initLayerMethods(list = []) {
				const configs = Array.isArray(list) ? list : []
				this.layerMethods = configs.map((item, index) => this.createLayerMethod(item, index))
				if (this.layerMethods.length === 0) {
					this.addLayerMethod()
					this.syncActiveRecordQueue()
					return
				}
				this.activeLayerId = this.layerMethods[0].id
				this.$nextTick(() => this.syncActiveRecordQueue())
			},
			createLayerMethod(item = {}, index = 0) {
				// 2026-07-29 分层方法模型：id 用于页面唯一性，ruleId 用于服务端规则主键，二者不能混用。
				return {
					id: item.layerId || item.id || `layer_${Date.now()}_${this.layerIdSeed++}_${index}`,
					ruleId: item.ruleId || item.serverId || 0,
					name: item.layerName || item.name || '',
					recording: false,
					stepCount: Number(item.stepCount || (Array.isArray(item.steps) ? item.steps.length : 0) || 0),
					steps: Array.isArray(item.steps) ? item.steps.map((step, stepIndex) => this.normalizeLayerStep(step, stepIndex)) : []
				}
			},
			normalizeLayerStep(step = {}, index = 0) {
				const trigger = step.triggerElement || {}
				const targetId = step.targetId || trigger.id || ''
				const name = step.name || step.operateName || (trigger.text && trigger.text !== '""' ? trigger.text : (targetId || step.funcName || '页面操作'))
				return {
					localId: step.localId || `step_${Date.now()}_${this.stepIdSeed++}_${index}`,
					funcName: step.funcName || '',
					targetId,
					name,
					args: Array.isArray(step.args) ? step.args : (step.args === undefined ? [] : [step.args]),
					timestamp: step.timestamp || step.operateTimestamp || Date.now(),
					triggerElement: {
						...trigger,
						id: trigger.id || targetId,
						text: trigger.text || name
					}
				}
			},
			addLayerMethod() {
				// 2026-07-29 新增分层：录制期间禁止新增，确保整个页面同一时刻只记录一个方法。
				if (this.hasRecordingLayer) {
					this.$message.warning('请先结束当前录制')
					return
				}
				const method = {
					id: this.createUniqueLayerId(),
					ruleId: 0,
					name: '',
					recording: false,
					steps: []
				}
				this.layerMethods.push(method)
				this.activeLayerId = method.id
			},
			removeLayerMethod(id) {
				const method = this.layerMethods.find(item => item.id === id)
				if (method && method.recording) {
					method.recording = false
					this.restoreConfigIframe()
				}
				this.layerMethods = this.layerMethods.filter(item => item.id !== id)
				if (this.activeLayerId === id) {
					this.activeLayerId = this.layerMethods[0] ? this.layerMethods[0].id : ''
				}
				this.$nextTick(() => this.syncActiveRecordQueue())
			},
			// 2026-07-29 HTML分层配置：服务端 stepCount 和本地 steps 统一成页面展示数量。
			getMethodStepCount(method) {
				if (!method) return 0
				if (Array.isArray(method.steps) && method.steps.length > 0) return method.steps.length
				return Number(method.stepCount || 0)
			},
			isMethodCompleted(method) {
				return !!method && !method.recording && this.getMethodStepCount(method) > 0
			},
			isAnotherMethodRecording(method) {
				return this.layerMethods.some(item => item.recording && item.id !== method.id)
			},
			getRecordButtonText(method) {
				if (method.recording) return '结束录制'
				if (this.isMethodCompleted(method)) return '已录制'
				return '开始录制'
			},
			getRecordButtonType(method) {
				if (method.recording) return 'warning'
				if (this.isMethodCompleted(method)) return 'info'
				return 'primary'
			},
			isRecordButtonDisabled(method) {
				if (!method) return true
				if (method.recording) return false
				if (this.isMethodCompleted(method)) return true
				return this.isAnotherMethodRecording(method)
			},
			toggleLayerRecord(method) {
				// 2026-07-29 录制状态机：未命名不能开始；已完成的方法必须重置后才能重录。
				if (!method.name) {
					this.$message.warning('请输入方法名称')
					return
				}
				if (this.hasInvalidLayerName(method.name)) {
					this.$message.warning('方法名称包含不合规内容')
					return
				}
				if (method.recording) {
					method.recording = false
					method.stepCount = method.steps.length
					this.activeLayerId = method.id
					this.restoreConfigIframe()
					this.$message.success(method.steps.length > 0 ? '已结束录制，可回放当前方法' : '已结束录制，当前方法暂无步骤')
					return
				}
				if (method.steps.length > 0) {
					this.$message.warning('当前方法已录制，如需重录请先重置')
					return
				}
				if (this.isAnotherMethodRecording(method)) {
					this.$message.warning('请先结束当前录制')
					return
				}
				if (this.playTimer) clearTimeout(this.playTimer)
				this.layerMethods.forEach(item => {
					if (item.id !== method.id) item.recording = false
				})
				this.isPlayMode = false
				this.showContinueOperateBtn = false
				this.state.isPause = false
				this.state.isPlaying = false
				this.activeLayerId = method.id
				this.syncActiveRecordQueue()
				this.restoreConfigIframe(() => {
					method.recording = true
					this.$message.success('开始录制当前分层方法')
				})
			},
			resetLayerMethod(method) {
				method.steps = []
				method.stepCount = 0
				method.recording = false
				this.activeLayerId = method.id
				this.syncActiveRecordQueue()
				this.$message.success('已重置当前分层方法')
			},
			hasInvalidLayerName(name) {
				return /[<>/"'`{}]|script|select|insert|delete|update|drop/i.test(name || '')
			},
			getActiveRecordingLayer() {
				return this.layerMethods.find(item => item.recording)
			},
			// 2026-07-29 HTML分层配置：底部停止录制按钮复用原录制状态，不触发保存接口。
			stopActiveLayerRecord() {
				const method = this.getActiveRecordingLayer()
				if (!method) return
				method.recording = false
				method.stepCount = method.steps.length
				this.activeLayerId = method.id
				this.restoreConfigIframe()
				this.$message.success(method.steps.length > 0 ? '已停止录制，可回放当前方法' : '已停止录制，当前方法暂无步骤')
			},
			closeLayerConfig() {
				if (this.hasRecordingLayer) {
					this.$message.warning('请先停止当前录制')
					return
				}
				this.$emit('close-config')
			},
			recordLayerStep(data) {
				const method = this.getActiveRecordingLayer()
				if (!method) return
				const trigger = data.triggerElement || {}
				const step = this.normalizeLayerStep({
					localId: `step_${Date.now()}_${this.stepIdSeed++}`,
					funcName: data.funcName,
					targetId: data.targetId || trigger.id || '',
					name: trigger.text && trigger.text !== '""' ? trigger.text : (trigger.id || data.funcName || '页面操作'),
					args: data.args || [],
					timestamp: data.timestamp || Date.now(),
					triggerElement: trigger
				})
				method.steps.push(step)
				method.stepCount = method.steps.length
				this.activeLayerId = method.id
				this.$nextTick(() => {
					const logBox = document.getElementById("logBox");
					if (logBox) logBox.scrollTop = logBox.scrollHeight;
				})
			},
			validateLayerConfig() {
				// 2026-07-29 保存前校验：名称、分层编号和步骤都合法时才允许调用保存接口。
				if (this.layerMethods.length === 0) {
					this.$message.warning('请先新增分层空间')
					return false
				}
				const names = new Set()
				const layerIds = new Set()
				for (const item of this.layerMethods) {
					if (!item.name) {
						this.$message.warning('请输入方法名称')
						this.activeLayerId = item.id
						return false
					}
					if (this.hasInvalidLayerName(item.name)) {
						this.$message.warning(`方法「${item.name}」名称不合规`)
						this.activeLayerId = item.id
						return false
					}
					if (names.has(item.name)) {
						this.$message.warning(`方法「${item.name}」名称重复`)
						this.activeLayerId = item.id
						return false
					}
					if (layerIds.has(item.id)) {
						this.$message.warning(`方法「${item.name}」分层编号重复`)
						this.activeLayerId = item.id
						return false
					}
					if (item.steps.length === 0) {
						this.$message.warning(`方法「${item.name}」还没有录制步骤`)
						this.activeLayerId = item.id
						return false
					}
					names.add(item.name)
					layerIds.add(item.id)
				}
				return true
			},
			async saveLayerConfig() {
				// 2026-07-29 保存分层规则：只提交当前配置页数据，并使用 HTML 上传记录主键关联规则。
				this.layerMethods.forEach(item => item.recording = false)
				if (!this.validateLayerConfig()) return
				const recordId = this.getHtmlUploadRecordId()
				if (!recordId) {
					this.$message.warning('请先保存HTML文件，生成htmlUploadRecordId后再保存分层规则')
					return
				}
				// 保存给分层规则接口的最小结构：steps 按接口要求转换成 JSON 字符串。
				const ruleList = this.layerMethods.map((item, index) => ({
					id: item.ruleId || 0,
					layerId: item.id,
					layerName: item.name.trim(),
					steps: JSON.stringify(item.steps.map((step, stepIndex) => ({
						sort: stepIndex + 1,
						funcName: step.funcName,
						targetId: step.targetId,
						name: this.displayStepName(step),
						args: step.args,
						timestamp: step.timestamp
					})))
				}))
				const payload = {
					htmlUploadRecordId: Number(recordId),
					ruleList
				}
				this.stratifiedSaving = true
				try {
					const res = await this.API.post(this.API.fileurl.postHtmlStratifiedSync, payload)
					// 2026-07-29 保存成功后回读规则列表：以服务端最新 ruleId 为准，保证再次进入能回放。
					this.syncRuleIdsFromSaveResponse(this.getResponseData(res))
					this.restoreConfigIframe()
					this.$message.success('HTML分层规则保存成功')
					this.$emit('update:layerConfig', this.layerMethods)
					this.$emit('save-layer-config', this.layerMethods)
					await this.loadStratifiedRules(true)
				} catch (err) {
					console.error('HTML分层规则保存失败', {
						err,
						payload
					})
					this.$message.error(err?.msg || err?.message || 'HTML分层规则保存失败')
				} finally {
					this.stratifiedSaving = false
				}
			},
			// 功能名称显示规则：表格“功能”列和保存结构里的 name 字段共用。
			displayStepName(step = {}) {
				return step.name || step.targetId || step.funcName || '页面操作'
			},
			// 参数显示规则：表格“参数”列保持 JSON 字符串，便于和回放 args 对应。
			formatStepArgs(args) {
				try {
					return JSON.stringify(args || [])
				} catch (e) {
					return '[]'
				}
			},
			// 回放队列只保留已有回放逻辑需要的函数名、目标元素、参数和操作时间。
			getPlaybackQueueFromSteps(steps = []) {
				return steps.map(step => ({
					funcName: step.funcName,
					targetId: step.targetId || '',
					args: Array.isArray(step.args) ? step.args : [],
					timestamp: step.timestamp
				}))
			},
			syncActiveRecordQueue() {
				if (!this.activeLayerMethod) {
					this.state.recordQueue = []
					this.resetPlayback()
					return
				}
				this.state.recordQueue = this.getPlaybackQueueFromSteps(this.activeLayerMethod.steps)
				this.resetPlayback()
			},
			playLayerMethod(method) {
				if (!method) return
				if (method.recording) {
					this.$message.warning('请先结束录制再回放')
					return
				}
				if (method.steps.length === 0) {
					this.$message.warning('当前方法暂无可回放步骤')
					return
				}
				this.layerMethods.forEach(item => item.recording = false)
				this.activeLayerId = method.id
				this.showContinueOperateBtn = false
				if (this.playTimer) clearTimeout(this.playTimer)
				this.isPlayMode = false
				this.state.isPause = false
				this.state.isPlaying = false
				this.$nextTick(() => {
					this.syncActiveRecordQueue()
					if (this.state.playQueue.length === 0) {
						this.$message.warning('当前方法暂无可回放步骤')
						return
					}
					this.startPlayback()
				})
			},
			restoreConfigIframe(afterLoaded) {
				const baseline = this.iframeUrlOrigin || this.iframeUrlPlay || this.currentIframeSrc
				if (!baseline) {
					if (typeof afterLoaded === 'function') afterLoaded()
					return
				}
				if (this.playTimer) clearTimeout(this.playTimer)
				this.isPlayMode = false
				this.showContinueOperateBtn = false
				this.state.isPause = false
				this.state.isPlaying = false
				this.state.currentPlayIndex = -1
				this.state.iframeReady = false
				this.currentIframeSrc = 'about:blank'
				this.$nextTick(() => {
					const iframe = document.getElementById("cubeIframe");
					if (!iframe) return
					iframe.onload = null;
					iframe.onerror = null;
					iframe.onload = () => {
						setTimeout(() => {
							this.state.iframeReady = true;
							this.syncActiveRecordQueue();
							if (typeof afterLoaded === 'function') afterLoaded()
						}, 300);
					};
					iframe.onerror = () => {
						this.$message.error("页面恢复失败");
						this.state.iframeReady = true;
						if (typeof afterLoaded === 'function') afterLoaded()
					};
					this.forBlod(baseline, "iframeUrlOrigin")
				})
			},
			handleCloseDialog() {
				this.ishtmlView = false
			},
			classToExl() {
				//全班分析Html操作
				this.ishtmlView = true
			},
			forMenuList() {
				this.htmlSimulation = false
				const MenuList = localStorage.getItem('MenuList')
				if (MenuList) {
					this.htmlSimulation = MenuList.includes('htmlSimulation')
				}
			},
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text: text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close()
				}
			},
			async getlistForPlayback() {
				if (this.isplayF == 0 || this.isplayF == 2) return
				this.state = {
					recordQueue: [],
					playQueue: [],
					currentPlayIndex: -1,
					isPause: false,
					isPlaying: false,
					iframeReady: false,
					logIndex: 0
				}
				this.loginOpen('学生操作数据加载中...')
				console.log('msgType', this.url)
				try {
					const list = await this.API.get(this.API.school.getlistForPlayback, {
						schoolId: localStorage.getItem("orgId"),
						courseClassId: this.courseClassId,
						studentId: this.studentId,
						msgType: this.url
					})
					this.newHtmlist(list.data)
				} catch (err) {
					this.noLogin()
				}
			},
			newHtmlist(list) {

				for (let i = 0; i < list.length; i++) {
					let data = list[i]
					this.forHtmlMessage(data)
				}
				this.noLogin()
			},
			forHtmlMessage(data) {

				const recordItem = {
					funcName: data.funcName,
					targetId: data.triggerElement.id || "",
					args: data.args,
					timestamp: data.operateTimestamp
				};
				this.state.recordQueue.push(recordItem);
				this.printLog(recordItem, data.triggerElement, this.state.recordQueue.length - 1);
				this.resetPlayback();
			},
			formatTime(ts) {
				const date = new Date(ts);
				const pad = n => String(n).padStart(2, '0');
				return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
			},

			printLog(item, triggerElement, index, isRunning = false) {
				var name = item.targetId || '-'
				if (triggerElement.text) {
					name = triggerElement.text == '""' ? triggerElement.id : (triggerElement.text || '-')
				}
				const tr = document.createElement("tr");
				tr.style.background = isRunning ? "#409EFF" : "#fff";
				tr.style.color = isRunning ? "#fff" : "#333";

				tr.innerHTML = `
        <td style="border:1px solid #ddd;padding:6px 4px;text-align:center;width:60px;">${index + 1}</td>
        <td style="border:1px solid #ddd;padding:6px 4px;">${name}</td>
        <td style="border:1px solid #ddd;padding:6px 4px;word-break:break-all;">${JSON.stringify(item.args)}</td>
        <td style="border:1px solid #ddd;padding:6px 4px;font-size:12px;">${this.formatTime(item.timestamp)}</td>
      `;
				document.getElementById("logTbody").appendChild(tr);
				const logBox = document.getElementById("logBox");
				logBox.scrollTop = logBox.scrollHeight;
			},

			triggerIframeBtn(funcName, args = [], targetId = "") {
				if (!this.state.iframeReady) return;
				const iframe = document.getElementById("cubeIframe");
				iframe.contentWindow.postMessage({
					type: "trigger_btn",
					funcName,
					targetId,
					args
				}, "*");
			},

			// 逐条执行回放
			runNextPlay() {
				const s = this.state;
				if (s.isPause) return;
				if (s.playQueue.length === 0) {
					s.isPlaying = false;
					s.currentPlayIndex = -1;
					this.showContinueOperateBtn = true;
					return;
				}
				s.isPlaying = true;
				const op = s.playQueue.shift();
				s.currentPlayIndex = s.recordQueue.length - s.playQueue.length - 1;

				// 执行当前操作
				this.triggerIframeBtn(op.funcName, op.args, op.targetId);
				// 高亮当前日志行
				document.querySelectorAll('#logTbody tr').forEach((row, i) => {
					row.style.background = i === s.currentPlayIndex ? "#409EFF" : "#fff";
					row.style.color = i === s.currentPlayIndex ? "#fff" : "#333";
				});
				// 保存定时器句柄，用于暂停/重置清除
				this.playTimer = setTimeout(() => this.runNextPlay(), 800);
			},

			resetPlayback() {
				// 清除旧回放定时器
				if (this.playTimer) clearTimeout(this.playTimer);
				const s = this.state;
				s.isPause = false;
				s.isPlaying = false;
				s.currentPlayIndex = -1;
				s.playQueue = JSON.parse(JSON.stringify(s.recordQueue));
				document.querySelectorAll('#logTbody tr').forEach(row => {
					row.style.background = "#fff";
					row.style.color = "#333";
				});
			},
			async forBlod(val, type) {
				try {
					let res = await fetch(val, {
						method: 'GET'
					})
					console.log('res', res)
					this.currentIframeSrc = val
				} catch (err) {
					console.log('异常')
					const releaseBlob = (url) => {
						if (url && url.startsWith('blob:')) URL.revokeObjectURL(url);
					}
					this.loginOpen('页面数据加载中...')
					if (type == 'iframeUrlOrigin') {
						releaseBlob(this.iframeUrlOrigin);
					} else {
						releaseBlob(this.iframeUrlPlay);
					}

					const blobUrl = await this.loadOssHtmlBlob(this.url)
					if (type == 'iframeUrlOrigin') {
						this.currentIframeSrc = URL.createObjectURL(blobUrl);
					} else {
						this.currentIframeSrc = URL.createObjectURL(blobUrl);
					}

				} finally {
					this.noLogin()
				}
			},
			async loadOssHtmlBlob(ossUrl) {
				try {
					const res = await fetch(ossUrl, {
						method: "GET",
						mode: "cors"
					});
					if (!res.ok) {
						throw new Error(`OSS请求失败，状态码：${res.status}，链接过期/无跨域权限`);
					}

					const rawBlob = await res.blob();
					const htmlBlob = new Blob([rawBlob], {
						type: "text/html;charset=utf-8"
					});

					return htmlBlob;
				} catch (err) {
					this.$message.error('读取OSS失败：' + err.message);
					console.error(err);
					return ''
				}
			},
			// 开始回放：切换基线页面
			startPlayback() {
				this.isp = true
				if (this.showContinueOperateBtn) {
					this.handleContinueOperate()
				}
				const s = this.state;
				if (s.isPlaying) return;
				if (s.playQueue.length === 0) return;
				this.resetPlayback();

				this.isPlayMode = true;
				this.cachePlaySnapshot = this.currentIframeSrc;
				this.showContinueOperateBtn = false;
				s.isPause = false;

				this.$nextTick(() => {
					const iframe = document.getElementById("cubeIframe");
					iframe.onload = null;
					iframe.onerror = null;
					iframe.onload = () => {
						const src = iframe.getAttribute('src') || ''
						if (!src || src === 'about:blank') return
						setTimeout(() => {
							this.state.iframeReady = true;
							this.runNextPlay();
						}, 300);
					};
					iframe.onerror = () => {
						this.$message.error("回放基线页面加载失败");
						this.state.isPlaying = false;
						this.state.iframeReady = true;
					};
					const baseline = this.iframeUrlOrigin || this.iframeUrlPlay
					if (!baseline) {
						this.$message.error("回放基线页面不存在")
						this.state.isPlaying = false
						this.isPlayMode = false
						return
					}
					if (this.currentIframeSrc === baseline) {
						this.currentIframeSrc = ''
						this.$nextTick(() => this.forBlod(baseline, "iframeUrlOrigin"))
					} else {
						this.forBlod(baseline, "iframeUrlOrigin")
					}
				});
			},

			pausePlayback() {
				this.state.isPause = true;
				if (this.playTimer) clearTimeout(this.playTimer);
			},

			resumePlayback() {
				const s = this.state;
				if (!s.isPlaying || !s.isPause) return;
				s.isPause = false;
				this.runNextPlay();
			},

			handleContinueOperate() {
				// 清除回放定时器
				if (this.playTimer) clearTimeout(this.playTimer);
				const s = this.state;
				s.isPlaying = false;
				s.isPause = false;
				this.isPlayMode = true;

				// 切回回放前缓存的操作页面
				this.forBlod(this.cachePlaySnapshot)
				// this.currentIframeSrc = this.cachePlaySnapshot;
				this.cachePlaySnapshot = "";

				document.querySelectorAll('#logTbody tr').forEach(row => {
					row.style.background = "#fff";
					row.style.color = "#333";
				});
				this.showContinueOperateBtn = false;

				this.$nextTick(() => {
					const iframe = document.getElementById("cubeIframe");
					iframe.onload = null;
					iframe.onerror = null;
					iframe.onload = () => {
						setTimeout(() => {
							this.state.iframeReady = true;
							this.resetPlayback();
						}, 200);
					};
					iframe.onerror = () => {
						this.$message.error("页面加载异常");
					};
					this.isp = false
				});
			},
			isDuplicateRecordMessage(data) {
				const msgKey = `${data.timestamp}_${data.funcName || data.type}_${data.triggerElement?.id || ""}`;
				if (this.msgCache.has(msgKey)) return true;
				this.msgCache.add(msgKey);
				setTimeout(() => this.msgCache.delete(msgKey), 1000);
				return false;
			},

			// 消息监听，替换全局缓存为组件私有Set
			onParentMessage(e) {
				const data = e.data;
				if (!data || !data.type) return;
				if (this.isPlayMode && data.type === "func_trigger_record") return;

				if (data.type === "func_trigger_record") {
					if (this.isDuplicateRecordMessage(data)) return;
					if (this.configMode) {
						this.recordLayerStep(data)
						return
					}
					if (this.isplayF == 2) {
						//上报记录e.data
						this.postSaveRecord(e.data)
					} else {
						const recordItem = {
							funcName: data.funcName,
							targetId: data.triggerElement.id || "",
							args: data.args,
							timestamp: data.timestamp
						};
						this.state.recordQueue.push(recordItem);
						this.printLog(recordItem, e.data.triggerElement, this.state.recordQueue.length - 1);
						this.resetPlayback();
					}

				}
			},
			async postSaveRecord(val) {
				try {
					let data = val
					data.type = this.url
					let params = {
						...data,
						"courseClassId": this.courseClassId,
						"studentId": this.studentId,
						"schoolId": localStorage.getItem("orgId"),
						"htmlIndex": this.htmlindex
					}


					let str = await this.API.post(this.API.student.postSaveRecord, params)

					if (str.status == 200) {
						console.log('入库成功')
						this.htmlindex = this.htmlindex + 1
					}
				} catch (err) {

				}
			},
		}
	};
</script>

<style>
	/* 配置/回放弹窗整体布局：桌面端左侧记录面板 + 右侧 iframe，移动端在媒体查询里改为上下结构。 */
	.html-iframe-shell {
		display: flex;
		width: 100%;
		height: calc(100vh - 100px);
		gap: 20px;
		box-sizing: border-box;
		padding: 20px 0;
		min-width: 0;
	}

	.html-iframe-sidebar {
		width: 460px;
		flex-shrink: 0;
		display: flex;
		flex-direction: column;
		gap: 16px;
		height: 100%;
		min-width: 0;
	}

	.html-iframe-stage {
		flex: 1;
		height: 100%;
		border: 2px solid #666;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		min-width: 0;
	}

	.iframe-stage-head {
		padding: 6px 12px;
		background: #eee;
		font-size: 14px;
	}

	/* 操作记录表头样式：对应“序号 / 功能 / 参数 / 操作时间”四列。 */
	.thTable {
		border: 1px solid #ddd;
		padding: 6px 4px;
		position: sticky;
		top: 0;
		background-color: royalblue;
		color: white;
	}

	.thTables {
		width: 60px;
	}

	/* HTML配置页左侧面板：承载分层方法列表和当前方法操作记录表。 */
	.layer-config-panel {
		flex: 1;
		min-height: 0;
		display: flex;
		flex-direction: column;
		background: #fff;
		border: 1px solid #e8edf5;
		border-radius: 8px;
		padding: 16px;
		box-shadow: 0 10px 28px rgba(31, 65, 105, .08);
		overflow: hidden;
	}

	.layer-config-head {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 12px;
		margin-bottom: 14px;
	}

	.layer-config-head h4 {
		margin: 0 0 6px;
		font-size: 17px;
		color: #172033;
	}

	.layer-config-head p {
		margin: 0;
		font-size: 12px;
		color: #7a8798;
		line-height: 1.5;
	}

	/* 分层方法列表样式：每个卡片对应一个老师新增的方法。 */
	.layer-method-list {
		flex: 0 0 auto;
		max-height: 220px;
		overflow-y: auto;
		padding-right: 4px;
		margin-bottom: 12px;
	}

	.layer-method-card {
		border: 1px solid #e8edf5;
		border-radius: 8px;
		padding: 12px;
		margin-bottom: 10px;
		background: #fbfdff;
		cursor: pointer;
		transition: border-color .18s ease, box-shadow .18s ease, background .18s ease;
	}

	.layer-method-card.active {
		border-color: rgba(64, 158, 255, .45);
		box-shadow: 0 8px 20px rgba(64, 158, 255, .1);
		background: #fff;
	}

	.layer-method-card.recording {
		border-color: rgba(230, 162, 60, .65);
		background: #fffaf2;
	}

	/* 方法名称输入行：序号、方法名、录制状态标签三块对齐。 */
	.method-top {
		display: grid;
		grid-template-columns: 28px minmax(0, 1fr) auto;
		align-items: center;
		gap: 8px;
	}

	.recording-pill {
		display: inline-flex;
		align-items: center;
		height: 24px;
		padding: 0 8px;
		border-radius: 999px;
		background: #fff4e5;
		color: #b56a10;
		font-size: 12px;
		white-space: nowrap;
	}

	.completed-pill {
		display: inline-flex;
		align-items: center;
		height: 24px;
		padding: 0 8px;
		border-radius: 999px;
		background: #eef5ff;
		color: #3b74c7;
		font-size: 12px;
		white-space: nowrap;
	}

	.rule-loading {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		min-height: 120px;
		color: #7a8798;
		font-size: 13px;
	}

	.method-index {
		width: 26px;
		height: 26px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background: #409EFF;
		color: #fff;
		font-weight: 700;
		font-size: 12px;
	}

	.method-actions {
		display: flex;
		align-items: center;
		gap: 8px;
		margin: 10px 0;
		flex-wrap: wrap;
	}

	.step-count {
		margin-left: auto;
		font-size: 12px;
		color: #667085;
	}

	/* 当前方法的操作记录区域：下方表格展示功能名称、参数和操作时间。 */
	.method-log-panel {
		flex: 1;
		min-height: 220px;
		display: flex;
		flex-direction: column;
		border: 1px solid #e1e6ef;
		border-radius: 8px;
		overflow: hidden;
		background: #fff;
	}

	.method-log-title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		padding: 10px 12px;
		border-bottom: 1px solid #e9edf5;
		background: #f7f9fc;
	}

	.method-log-title strong {
		display: block;
		max-width: 220px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		color: #172033;
	}

	.method-log-title span {
		display: block;
		margin-top: 2px;
		font-size: 12px;
		color: #7a8798;
	}

	.config-log-box {
		width: 100%;
		flex: 1;
		overflow: auto;
		background: #fff;
	}

	.config-log-table {
		width: 100%;
		border-collapse: collapse;
		table-layout: fixed;
		font-family: monospace;
	}

	/* 记录表普通单元格：功能名称和参数列共用，长文本自动换行避免撑破布局。 */
	.log-td {
		border: 1px solid #ddd;
		padding: 7px 6px;
		color: #333;
		font-size: 12px;
		line-height: 1.35;
		vertical-align: top;
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: break-word;
	}

	.log-index {
		width: 60px;
		text-align: center;
	}

	/* 参数列样式：对应 formatStepArgs(step.args) 输出。 */
	.log-args {
		max-width: 160px;
	}

	/* 操作时间列样式：对应 formatTime(step.timestamp) 输出。 */
	.log-time {
		width: 120px;
		font-size: 12px;
		color: #606266;
	}

	.empty-log-cell {
		padding: 28px 12px;
		text-align: center;
		color: #a0a8b5;
		border: 1px solid #ddd;
		font-size: 13px;
	}

	.layer-config-footer {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
		padding-top: 12px;
		border-top: 1px solid #edf1f7;
	}

	@media (max-width: 1180px) {
		.html-iframe-sidebar {
			width: 400px;
		}

		.method-actions .el-button {
			margin-left: 0;
		}
	}

	@media (max-width: 900px) {
		.html-iframe-shell {
			flex-direction: column;
			height: auto;
			min-height: calc(100vh - 100px);
			padding: 12px 0;
		}

		.html-iframe-sidebar {
			width: 100%;
			height: auto;
			max-height: none;
		}

		.html-iframe-stage {
			min-height: 58vh;
		}

		.layer-config-panel {
			padding: 12px;
			max-height: none;
		}

		.layer-config-head {
			flex-direction: column;
		}

		.layer-method-list {
			max-height: none;
		}

		.method-log-panel {
			min-height: 260px;
		}

		.method-log-title {
			align-items: flex-start;
			flex-direction: column;
		}
	}

	@media (max-width: 560px) {
		.method-top {
			grid-template-columns: 24px minmax(0, 1fr);
		}

		.recording-pill {
			grid-column: 2;
			width: max-content;
		}

		.step-count {
			width: 100%;
			margin-left: 0;
		}
	}
</style>
